import React, { useEffect } from 'react';
import styles from './MessagesPerConversation.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useFetch } from 'hooks/useFetch';
import { dashboardEndpoints } from 'hooks/endpoints';
import Loader from 'component/atom/loader/Loader';

const truncate2 = (n) => (((n ?? 0) * 100) | 0) / 100;

const MessagesPerConversation = ({ startDate, endDate, botId, botType }) => {
  const { data, refetch, isLoading, isFetching } = useFetch(
    ['messagesPerConversation', startDate, endDate, botId, botType],
    dashboardEndpoints.getMessagesPerConversation(startDate, endDate),
    { enabled: false },
    botId ? { botId: botId, chatSource: botType } : {}
  );

  useEffect(() => {
    if (botType !== undefined) {
      refetch();
    }
  }, [startDate, endDate, botType, botId]);

  const currentAvg = data?.data?.currentWindow?.average ?? 0;
  const prevAvg = data?.data?.previousMonthWindow?.average ?? 0;

  let changePctTrunc = 0;
  let isPositive = false;
  let isNegative = false;

  if (prevAvg === 0) {
    if (currentAvg > 0) {
      changePctTrunc = 100;
      isPositive = true;
    } else {
      changePctTrunc = 0;
    }
  } else {
    const changePct = ((currentAvg - prevAvg) / prevAvg) * 100;
    changePctTrunc = Math.trunc(changePct * 100) / 100;
    isPositive = changePctTrunc > 0;
    isNegative = changePctTrunc < 0;
  }

  const showArrow = changePctTrunc !== 0;

  const color = isNegative ? '#DB161B' : isPositive ? '#01931A' : '#F08800';
  const backgroundColor = isNegative
    ? '#FBE3E4'
    : isPositive
    ? '#E0FFE5'
    : '#FFF7EC';
  const arrowRotation = isPositive ? 'rotate(180deg)' : 'none';

  return (
    <div className={styles['messages-per-conversation-container']}>
      <div className={styles['title-container']}>
        <SvgWithBranding type='messagesConversation' />
        <span className={styles['title']}>Messages per Conversation</span>
      </div>
      <span className={styles['description']}>
        Average number of messages exchanged in each conversation.
      </span>
      <span className={styles['average']}>
        {isFetching || isLoading ? (
          <Loader />
        ) : (
          truncate2(currentAvg).toFixed(2)
        )}
      </span>
      {/* <div className={styles['percentage-change-container']}>
        <div
          className={styles['percentage-card']}
          style={{ color, backgroundColor, borderColor: color }}
        >
          {showArrow && (
            <div style={{ transform: arrowRotation }}>
              <SvgWithBranding type='down_arrow' color={color} height={12} />
            </div>
          )}
          <span className={styles['percentage-change']} style={{ color }}>
            {isPositive
              ? `+${
                  Number.isInteger(changePctTrunc)
                    ? changePctTrunc
                    : changePctTrunc.toFixed(2)
                }%`
              : isNegative
              ? `-${
                  Number.isInteger(Math.abs(changePctTrunc))
                    ? Math.abs(changePctTrunc)
                    : Math.abs(changePctTrunc).toFixed(2)
                }%`
              : `${
                  Number.isInteger(changePctTrunc)
                    ? changePctTrunc
                    : changePctTrunc.toFixed(2)
                }%`}
          </span>
        </div>
        <span className={styles['duration']}>from last month</span>
      </div> */}
    </div>
  );
};

export default MessagesPerConversation;
